<template lang="pug">
span
  v-menu(v-model="showMenu" rounded="lg" allow-overflow attach :close-on-content-click="false" offset-y max-height="360" min-width="320" max-width="320" nudge-bottom="8" content-class="custom-menu")
    template(v-slot:activator="{ on, attrs }")
      v-btn.px-2.button-text-normal.button-filter.text-none(v-if="showSelectedText" outlined rounded height="28" v-bind="attrs" v-on="on")
        v-icon.mr-1(@click.stop="clear" size=13) $yzi-x-circle
        .text-xs.font-semibold {{ title }}
        .px-1.neutral400--text | 
        .text-xs.primary--text.font-medium {{ selectedName }} 
          template(v-if="selectedOption === 'duration'")
            span {{ `${selectedDurationValue} ${duration}s` }} 
          template(v-else)
            span {{ selectedValue }}
            span(v-if="selectedOption === 'between'") -{{ selectedEndValue }}
        v-icon.ml-1(size=16) $yzi-chevron-down
      v-btn.px-2.button-text-normal.border-dashed.button-filter(v-else outlined rounded height="28" v-bind="attrs" v-on="on")
        v-icon.mr-1(size=13) $yzi-plus-circle
        .text-xs.text-none.font-semibold {{ title }}

    .pa-4.white(style="border-radius: inherit;")
      .font-semibold.mb-3.text-sm {{ $t('filter_by') }} {{ title.toLowerCase() }}
      y-select.mb-2(v-model="option" :items="options" item-value="id" item-text="name" small attach)
      .d-flex.align-start
        v-icon.mx-2(size=16 color="primary") $yzi-corner-down-right
        template(v-if="option === 'duration'")
          v-text-field.round-xl(v-model="durationValue" hide-details outlined dense placeholder="Value" type="number")
          y-select.ml-2(v-model="duration" :items="durations" item-value="id" item-text="name" small attach)
        template(v-else)
          date-dropdown(:parentDate.sync="value")
          template(v-if="option === 'between'")
            .text-xs.mt-3.mx-2.neutral500--text.text-lowercase {{ $t('to') }}
            date-dropdown(:parentDate.sync="endValue")

    .bottom-0.sticky.z-1.white(style="border-radius: inherit;")
      .d-flex.align-center.px-4.py-3.border-t
        .text-sm.font-semibold.underline.normal-case.neutral700--text.cursor-pointer(v-if="!disabledButton" @click="clear") {{ $t('clear') }}
        v-spacer
        v-btn.button-sm(@click="apply" color="primary" depressed :disabled="disabledButton") {{ $t('apply') }}

</template>

<script>
import DateDropdown from './DateDropdown.vue'
import { DateTime } from 'luxon'

export default {
  name: 'FilterDate',
  components: { DateDropdown },
  props: {
    filter: {
      type: Object,
      default: (() => {})
    },
    title: {
      type: String,
      default: 'Date'
    },
    param: {
      type: String,
      default: 'date'
    },
    checkInitialValue: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showMenu: false,
      option: `${this.param}`,
      duration: 'day',
      durationValue: null,
      value: null,
      endValue: null,
      selectedDurationValue: null,
      selectedOption: null,
      selectedValue: null,
      selectedEndValue: null,
      options: [
        { id: `${this.param}`, name: 'Is equal to' },
        { id: 'duration', name: 'Is in the last' },
        { id: 'between', name: 'Is between' },
        { id: `${this.param}__gt`, name: 'Is after' },
        { id: `${this.param}__gte`, name: 'Is on or after' },
        { id: `${this.param}__lt`, name: 'Is before' },
        { id: `${this.param}__lte`, name: 'Is before or on' },
      ],
      durations: [
        { id: 'day', name: 'Days' },
        { id: 'week', name: 'Weeks' },
        { id: 'month', name: 'Months' },
        { id: 'year', name: 'Years' },
      ],
    }
  },
  computed: {
    selectedName () {
      for (const key in this.options) {
        const val = this.options[key]
        if (val.id === this.selectedOption) {
          return val.name
        }
      }
      return null
    },
    showSelectedText () {
      if (this.selectedOption === 'duration') {
        return this.selectedDurationValue !== null
      }
      return this.selectedValue
    },
    disabledButton () {
      if (this.option === 'duration') {
        return !this.durationValue
      }
      if (this.option === 'between') {
        return !(this.endValue && this.value)
      }
      return !this.value
    }
  },
  watch: {
    filter: {
      handler () {
        if (!this.filter.key) { this.clearData() }
      } 
    },
  },
  mounted () {
    this.setData()
  },
  methods: {
    setData () {
      if (this.checkInitialValue) {
        if (this.filter.key) {
          this.selectedOption = this.filter.key
          this.option = this.filter.key
          if (this.filter.key === 'between' && this.filter.value.length) {
            this.value = this.filter.value[0].value
            this.endValue = this.filter.value[1].value
            this.selectedValue = this.filter.value[0].value
            this.selectedEndValue = this.filter.value[1].value
          } else {
            this.value = (this.filter.value)
            this.selectedValue = (this.filter.value)
          }
        }
      }
    },
    clear () {
      this.clearData()
      this.$emit('update:filter', {})
    },
    clearData () {
      this.value = null
      this.endValue = null
      this.selectedOption = null
      this.selectedValue = null
      this.selectedEndValue = null
      this.durationValue = null
      this.selectedDurationValue = null
    },
    getDateFromDuration () {
      let date = DateTime.local()
      switch (this.duration) {
        case 'day':
          date = date.minus({ days: this.durationValue })
          break
        case 'week':
          date = date.minus({ weeks: this.durationValue })
          break
        case 'month':
          date = date.minus({ months: this.durationValue })
          break
        case 'year':
          date = date.minus({ years: this.durationValue })
          break
      }
      return date.toFormat('yyyy-MM-dd')
    },
    apply () {
      this.showMenu = false
      this.selectedOption = this.option
      this.selectedValue = this.value
      this.selectedEndValue = this.endValue
      this.selectedDurationValue = this.durationValue
      let filter = { key: this.option, value: this.value }
      if (this.option === 'between') {
        filter = { 
          key: this.option, 
          value: [
            { key: `${this.param}__lte`, value: this.endValue },
            { key: `${this.param}__gte`, value: this.value },
          ]
        }
      }
      if (this.option === 'duration') {
        filter = { key: `${this.param}__gte`, value: this.getDateFromDuration()}
      }
      this.$emit('update:filter', filter)
    }
  }
}
</script>

<style lang="scss" scoped>
.button-filter {
  min-width: 0 !important;
  color: #848484;
}
::v-deep {
  .custom-menu {
    overflow: unset;
    contain: unset;
  }
}
</style>